import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DownloadStatusPage } from './download-status.page';

const routes: Routes = [
  {
    path: '',
    component: DownloadStatusPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DownloadStatusPageRoutingModule {}
